module.exports = __webpack_public_path__ + "static/media/震前防災教育管道 vs 地震發生時有沒有到空曠處避難.e5c21d63.xlsx";